var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myTile"},[_c('p',{staticClass:"title is-3 is-6-mobile"},[_vm._v("and keeps spreading")]),_vm._m(0),_c('div',[_c('GChart',{attrs:{"type":"LineChart","data":_vm.dailyInfectionLineChart,"options":{
        backgroundColor: '#F0F0F0',
        chartArea: {backgroundColor: '#F0F0F0'}, 
        legend: {position: 'none'}, 
        lineWidth: 6,
        series: {0: {color: '#3298DC'}},
        hAxis: {
          format: 'M/d',
          gridlines: {count: -1},
          minorGridlines: {units: {days: {format: 'M/d'}}}
        }
      }}})],1),_vm._m(1),_c('div',[_c('GChart',{attrs:{"type":"LineChart","data":_vm.cumInfectionLineChart,"options":{
        backgroundColor: '#F0F0F0',
        chartArea: {backgroundColor: '#F0F0F0'}, 
        legend: {position: 'none'}, 
        lineWidth: 6,
        series: {0: {color: '#3298DC'}},
        hAxis: {
          format: 'M/d',
          gridlines: {count: -1},
          minorGridlines: {units: {days: {format: 'M/d'}}}
        }
      }}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-left"},[_c('p',[_vm._v("The number of new cases peaked in the first few days of the pandemic, before slowly tapering off. As more users became infected, the rate of infections slowed significantly and \"flattened\" the curve.")]),_c('br'),_c('p',{staticClass:"chartTitle"},[_vm._v("Figure 2: New infections by day")]),_c('hr',{staticClass:"rule"})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"has-text-left"},[_c('br'),_c('p',{staticClass:"chartTitle"},[_vm._v("Figure 3: Cumulative infections by day")]),_c('hr',{staticClass:"rule"})])
}]

export { render, staticRenderFns }